export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: { default: 'opt' }
  },
  {
    title: that.$l('table_label_orderNo') || '订单编号',
    field: 'orderNo',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_platformOrderNo') || '电商平台订单编号',
    field: 'platformOrderNo',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_subscriber') || '平台',
    field: 'subscriber',
    minWidth: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_eventName') || '事件名称',
    field: 'eventName',
    minWidth: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_pushStatus') || '推送状态',
    field: 'pushStatus',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'pushStatus' },
  },
  {
    title: that.$l('table_label_pushResult') || '推送结果',
    field: 'pushResult',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_maxRetryCount') || '最大重试次数',
    field: 'maxRetryCount',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_retryCount') || '当前重试次数',
    field: 'retryCount',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_pushpushTime') || '推送时间',
    field: 'pushTime',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_errorEmailNotificationStatus') || '邮件通知状态',
    field: 'v_errorEmailNotificationStatus',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'errorEmailNotificationStatus' },
  },
  {
    title: that.$l('table_label_errorEmailNotificationTime') || '邮件通知时间',
    field: 'errorEmailNotificationTime',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.create_date') || '创建时间',
    field: 'createTime',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  }
]
